// extracted by mini-css-extract-plugin
export default {"txSide":"EbzL5B62Fe3iTWv6Uhc1","title":"oLH5FFZkPrxRJlAAa9uo","highlighted":"KKoyF1IPghYVOAsMc3Ys","avatar":"DV_v9hriRJ8OZDjrhZOe","address":"oCnbtSZjr535ItB8MFOC"};